import axios from "axios";

import { ApiClientsContext } from "apps/website/contexts/api";
import {
  IGetPostCheckoutChargesResponse,
  IGetPostCheckoutChargesResponseLegacy,
} from "@api-clients/charges";

const MAX_RETRIES = 10;
const RETRY_DELAY_MS = 2000;
const HTTP_STATUS_OK = 200;

const sleep = (n: number) => new Promise((res) => {
  setTimeout(res, n);
});

async function attemptFetchPostCheckoutChargeLegacy(
  api: ApiClientsContext,
  customerId?: string,
): Promise<IGetPostCheckoutChargesResponseLegacy | null> {
  try {
    console.log("fetching post checkout charge with legacy version");
    return await api.Charges.getPostCheckoutChargesLegacy(customerId);
  } catch (e) {
    if (axios.isAxiosError(e) && e?.response?.status === HTTP_STATUS_OK) {
      console.error(`axiosError: failed to get customer data for [katkinCustomerId=${customerId}]`, e);
      return null;
    }

    if (!axios.isAxiosError(e)) {
      console.error(`failed to get customer data for [katkinCustomerId=${customerId}]`, e);
      return null;
    }

    console.error(`axiosError: bad response when getting customer data for [katkinCustomerId=${customerId}], retrying...`, e);
    throw e;
  }
}

async function attemptFetchPostCheckoutCharge(
  api: ApiClientsContext,
): Promise<IGetPostCheckoutChargesResponse | null> {
  try {
    console.log("fetching post checkout charge with new version");
    return await api.Charges.getPostCheckoutCharges();
  } catch (e) {
    if (axios.isAxiosError(e) && e?.response?.status === HTTP_STATUS_OK) {
      console.error("axiosError: failed to get customer data", e);
      return null;
    }

    if (!axios.isAxiosError(e)) {
      console.error("failed to get customer data", e);
      return null;
    }

    console.error("axiosError: bad response when getting customer data, retrying...", e);
    throw e;
  }
}

export async function fetchPostCheckoutChargeWithRetryLegacy(
  api: ApiClientsContext,
  customerId?: string,
): Promise<IGetPostCheckoutChargesResponseLegacy | null> {
  let retries = MAX_RETRIES;

  while (retries > 0) {
    try {
      console.log("attempting to fetch post checkout charge (legacy)");
      return await attemptFetchPostCheckoutChargeLegacy(api, customerId);
    } catch {
      await sleep(RETRY_DELAY_MS);
      retries -= 1;
    }
  }

  return null;
}

export async function fetchPostCheckoutChargeWithRetry(
  api: ApiClientsContext,
): Promise<IGetPostCheckoutChargesResponse | null> {
  let retries = MAX_RETRIES;

  while (retries > 0) {
    try {
      console.log("attempting to fetch post checkout charge");
      return await attemptFetchPostCheckoutCharge(api);
    } catch {
      await sleep(RETRY_DELAY_MS);
      retries -= 1;
    }
  }

  return null;
}
